import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK } from '../etikettendruck.shared';
import { EtikettendruckStore } from '../store/etikettendruckStore';

@Injectable()
export class EtikettendruckResolver {
  private readonly store = inject(Store);

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): { etikettenart: string | undefined } {
    const art = this.store.get(
      SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK,
      EtikettendruckStore.getters.art
    );
    console.log('[EtikettendruckResolver] resolve', { url: state.url, art });
    return { etikettenart: art as string | undefined };
  }
}
